import "./estilos.css";
import { useEffect, useState, useRef } from "react";
import { getCTXRlist, getCTXRlistGlobal } from "../request/request";
import { useAppSelector } from "../../../../../redux/hooks";
import { useAuth } from "../../../auth";
import axios from "axios";
import Swal from "sweetalert2";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import styles from "../../statusGral/cloudStatusTable.module.scss";
import { format } from "date-fns";
import GenericDateTimeRangePicker, {
  GenericDateTimeRangeValue,
} from "./Datetime/GenericDateTimeRangePicker";

const API_URL = process.env.REACT_APP_API_URL;

type logs = {
  id: number;
  ctxrId: number;
  level: string;
  log: string;
  timestamp: string;
};

interface LogsResponse {
  hits?: logs[];
  nextSortValues?: string[];
  total?: {
    value: number;
    relation: string;
  };
  error?: string;
}

export default function LogsTable(props: any) {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const { currentUser } = useAuth();
  const tenant = useAppSelector((state) => state.TenantSlice.id);
  const Id = useAppSelector((state) => state.SuscriptionSlice.id);
  const Type = useAppSelector((state) => state.CloudSlice.Type);
  const nameregion = useAppSelector((state) => state.RegionSlice.name);

  const [Devices, setDevices] = useState<any | null>([]);
  const [DeviceSelect, setselect] = useState<string>("");

  const [predefinedRange, setPredefinedRange] = useState<string>("");
  const [showDateTimeFields, setShowDateTimeFields] = useState<boolean>(false);

  const [dateRange, setDateRange] = useState<GenericDateTimeRangeValue>({
    start: null,
    end: null,
  });

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [searchColumn, setSearchColumn] = useState("All");
  const [selectedSeverity, setSelectedSeverity] = useState<string>("");

  const [Records, setRecords] = useState<logs[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");

  const [endTimeStr, setEndTimeStr] = useState<string>("");

  const [nextSortValues, setNextSortValues] = useState<string[] | null>(null);

  const handlePredefinedChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setPredefinedRange(value);

    if (value === "custom") {
      setShowDateTimeFields(true);
      setDateRange({ start: null, end: null });
    } else {
      setShowDateTimeFields(false);
      const now = new Date();
      let start = new Date(now.getTime());
      switch (value) {
        case "lastHour":
          start.setHours(now.getHours() - 1);
          break;
        case "last24":
          start.setDate(now.getDate() - 1);
          break;
        case "today":
          start.setHours(0, 0, 0, 0);
          break;
        case "yesterday":
          start.setDate(now.getDate() - 1);
          start.setHours(0, 0, 0, 0);
          break;
      }
      setDateRange({ start, end: now });
    }
  };

  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const getSortIcon = (col: string) => {
    if (sortColumn === col) {
      return sortDirection === "asc" ? (
        <KeyboardArrowUpIcon className={styles["sort-icon"]} />
      ) : (
        <KeyboardArrowDownIcon className={styles["sort-icon"]} />
      );
    }
    return (
      <ImportExportIcon
        className={styles["sort-icon"]}
        style={{ opacity: 0.7 }}
      />
    );
  };

  function applySearch(data: logs[]) {
    if (!searchTerm) return data;
    const lowerTerm = searchTerm.toLowerCase();
    return data.filter((d) => {
      if (searchColumn === "All") {
        return (
          d.timestamp?.toLowerCase().includes(lowerTerm) ||
          d.level?.toLowerCase().includes(lowerTerm) ||
          d.log?.toLowerCase().includes(lowerTerm)
        );
      } else {
        const val = (d as any)[searchColumn]?.toString().toLowerCase() || "";
        return val.includes(lowerTerm);
      }
    });
  }

  function applySort(data: logs[]) {
    if (!sortColumn) return data;
    return [...data].sort((a, b) => {
      if (sortColumn === "timestamp") {
        const dateA = new Date(a.timestamp).getTime();
        const dateB = new Date(b.timestamp).getTime();
        return sortDirection === "asc" ? dateA - dateB : dateB - dateA;
      } else {
        const valA = (a as any)[sortColumn]?.toLowerCase();
        const valB = (b as any)[sortColumn]?.toLowerCase();
        if (valA < valB) return sortDirection === "asc" ? -1 : 1;
        if (valA > valB) return sortDirection === "asc" ? 1 : -1;
        return 0;
      }
    });
  }

  const filteredData = applySearch(Records);
  const sortedData = applySort(filteredData);

  const Datoslogs = async () => {
    setRecords([]);
    setHasMore(false);
    setNextSortValues(null);

    if (
      DeviceSelect &&
      dateRange.start &&
      dateRange.end &&
      currentUser?.ListPermiso?.includes("CTXR.Neighbor.List")
    ) {
      try {
        setLoading(true);
        const startDateStr = format(dateRange.start, "yyyy-MM-dd");
        const startTimeStr = format(dateRange.start, "HH:mm:ss");
        const endDateStr = format(dateRange.end, "yyyy-MM-dd");
        const endTimeStrLocal = format(dateRange.end, "HH:mm:ss");

        const paramsObject: any = {};
        if (selectedSeverity) paramsObject.logLevel = selectedSeverity;
        if (searchTerm) paramsObject.searchTerm = searchTerm;

        paramsObject.startDate = startDateStr;
        paramsObject.startTime = startTimeStr;
        paramsObject.endDate = endDateStr;
        paramsObject.endTime = endTimeStrLocal;

        setEndTimeStr(endTimeStrLocal);

        if (tenant !== 0) {
          paramsObject.tenantId = tenant;
        }

        const res = await axios.get<LogsResponse>(
          `${API_URL}/v1/ctxr/getLogRecordsForCtxr/${DeviceSelect}`,
          { params: paramsObject }
        );


        if (res.data.error) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "No logs available for the selected date",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          if (res.data.hits && Array.isArray(res.data.hits)) {
            if (res.data.hits.length > 0) {
              setRecords(res.data.hits as logs[]);
              setHasMore(true);
            } else {
              setHasMore(false);
            }
            if (res.data.nextSortValues) {
              setNextSortValues(res.data.nextSortValues);
            }
          } else if (Array.isArray(res.data)) {
            if (res.data.length > 0) {
              setRecords(res.data as logs[]);
              setHasMore(true);
            } else {
              setHasMore(false);
            }
          } else {
            setHasMore(false);
          }
        }
      } catch (error) {
        console.log("Error en Datoslogs:", error);
      } finally {
        setLoading(false);
      }
    } else {
      if (!dateRange.start) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Start Date/Time is required",
          showConfirmButton: false,
          timer: 2000,
        });
      } else if (!dateRange.end) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "End Date/Time is required",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    }
  };

  const DatoslogsScroll = async (horaForm: string) => {
    if (
      Id !== 0 &&
      DeviceSelect !== "" &&
      dateRange.end &&
      currentUser?.ListPermiso?.includes("CTXR.Neighbor.List")
    ) {
      try {
        setLoading(true);
        const paramsObject: any = {};
        if (selectedSeverity) paramsObject.logLevel = selectedSeverity;
        if (searchTerm) paramsObject.searchTerm = searchTerm;

        if (tenant !== 0) {
          paramsObject.tenantId = tenant;
        }

        if (nextSortValues) {
          paramsObject.lastSortValues = JSON.stringify(nextSortValues);

          const res = await axios.get<LogsResponse>(
            `${API_URL}/v1/ctxr/getLogRecordsForCtxr/${DeviceSelect}`,
            { params: paramsObject }
          );

          if (res.data.error) {
            console.error("No logs available");
            setHasMore(false);
          } else {
            if (res.data.hits && Array.isArray(res.data.hits)) {
              if (res.data.hits.length > 0) {
                setRecords((prev) => [...prev, ...(res.data.hits as logs[])]);
              } else {
                setHasMore(false);
              }
              if (res.data.nextSortValues) {
                setNextSortValues(res.data.nextSortValues);
              } else {
                setNextSortValues(null);
                setHasMore(false);
              }
            } else if (Array.isArray(res.data)) {
              if (res.data.length > 0) {
                setRecords((prev) => [...prev, ...(res.data as logs[])]);
              } else {
                setHasMore(false);
              }
            } else {
              setHasMore(false);
            }
          }
        } else {
          paramsObject.endDate = format(dateRange.end, "yyyy-MM-dd");
          paramsObject.endTime = horaForm;

          const res = await axios.get<LogsResponse>(
            `${API_URL}/v1/ctxr/getLogRecordsForCtxr/${DeviceSelect}`,
            { params: paramsObject }
          );

          if (res.data.error) {
            console.error("No logs available");
          } else {
            if (res.data.hits && Array.isArray(res.data.hits)) {
              if (res.data.hits.length > 0) {
                setRecords((prev) => [...prev, ...(res.data.hits as logs[])]);
              } else {
                setHasMore(false);
              }
            } else if (Array.isArray(res.data)) {
              if (res.data.length > 0) {
                setRecords((prev) => [...prev, ...(res.data as logs[])]);
              } else {
                setHasMore(false);
              }
            }
          }
        }
      } catch (error) {
        console.error("Error en DatoslogsScroll:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const contenedor = containerRef.current;
    if (!contenedor || !hasMore || loading) return;

    const handleScroll = () => {
      const margenDeError = 10;
      const estaEnLaParteInferior =
        contenedor.scrollTop + contenedor.clientHeight + margenDeError >=
        contenedor.scrollHeight;
      if (estaEnLaParteInferior) {
        setEndTimeStr("");
        if (endTimeStr === "" && Records.length > 0) {
          const ultimoRegistro = Records[Records.length - 1];
          const isoTimestamp = ultimoRegistro.timestamp;
          const horaForm = isoTimestamp.substring(11, 19);
          DatoslogsScroll(horaForm);
        }
      }
    };

    contenedor.addEventListener("scroll", handleScroll);
    return () => {
      contenedor.removeEventListener("scroll", handleScroll);
    };
  }, [loading, hasMore, endTimeStr, Records, nextSortValues]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id && tenant === 0 && Type !== "CloudGlobal") {
          const ctxr = await getCTXRlist(Id, Type, nameregion);
          if (ctxr.data && ctxr.data.error === "id suscription invalido") {
            setDevices([]);
          } else {
            setDevices(ctxr.data);
          }
        } else if (Id && tenant !== 0 && Type !== "CloudGlobal") {
          const ctxr = await getCTXRlistGlobal(Id, tenant, Type, nameregion);
          if (ctxr.data && ctxr.data.error === "id suscription invalido") {
            setDevices([]);
          } else {
            setDevices(ctxr.data);
          }
        } else if (Id === -1 && tenant === 0) {
          const ctxr = await getCTXRlist(-1);
          if (ctxr.data && ctxr.data.error === "id suscription invalido") {
            setDevices([]);
          } else {
            setDevices(ctxr.data);
          }
        } else if (Id === -1 && tenant !== 0) {
          const ctxr = await getCTXRlistGlobal(-1, tenant);
          if (ctxr.data && ctxr.data.error === "id suscription invalido") {
            setDevices([]);
          } else {
            setDevices(ctxr.data);
          }
        } else if (
          Id !== 0 &&
          Id !== -1 &&
          tenant === 0 &&
          Type === "CloudGlobal"
        ) {
          const ctxr = await getCTXRlist(Id);
          if (ctxr.data && ctxr.data.error === "id suscription invalido") {
            setDevices([]);
          } else {
            setDevices(ctxr.data);
          }
        } else if (
          Id !== 0 &&
          Id !== -1 &&
          tenant !== 0 &&
          Type === "CloudGlobal"
        ) {
          const ctxr = await getCTXRlistGlobal(Id, tenant);
          if (ctxr.data && ctxr.data.error === "id suscription invalido") {
            setDevices([]);
          } else {
            setDevices(ctxr.data);
          }
        }
      } catch (error) {
        console.error("Error al obtener las cuentas:", error);
      }
    };
    fetchData();
  }, [Id, tenant, Type, nameregion, props.num]);

  const cambiarstate = (e: any) => {
    setselect(e.target.value);
  };

  return (
    <>
      <div className="grid min-h-screen w-full md:grid-cols-[240px_1fr] gap-4 p-4">
        <div className="flex flex-col items-center gap-6">
          <h1 className="f-titulo fs-md mb-3 text-marino text-center">
            System Logs
          </h1>
          <br />

          <div
            className="d-flex align-items-end justify-content-between mb-4"
            style={{ gap: "10px" }}
          >
            <div
              className="d-flex flex-wrap align-items-end"
              style={{ gap: "10px" }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label className="form-label f-bold fs-p text-marino required">
                  CTX-R Name
                </label>
                <select
                  aria-label="Select example"
                  onChange={cambiarstate}
                  value={DeviceSelect}
                  className="form-select border-marino f-parrafo fs-p text-dk text-center"
                  style={{
                    width: "295px",
                    height: "40px",
                  }}
                >
                  {Devices.length === 0 && <option hidden>No data</option>}
                  <option hidden defaultValue="">
                    Select a Device
                  </option>
                  {Devices.map((ins: any, x: any) => (
                    <option key={x} value={ins.id}>
                      {ins.name} ({ins.description})
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label className="form-label f-bold fs-p text-marino">
                  Severity Level
                </label>
                <select
                  aria-label="Select severity level"
                  onChange={(e) => setSelectedSeverity(e.target.value)}
                  value={selectedSeverity}
                  className="form-select border-marino f-parrafo fs-p text-dk text-center"
                  style={{
                    width: "135px",
                    height: "40px",
                  }}
                >
                  <option value="">All Levels</option>
                  <option value="ERROR">Error</option>
                  <option value="DEBUG">Debug</option>
                  <option value="INFO">Info</option>
                  <option value="WARNING">Warning</option>
                </select>
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label className="form-label f-bold fs-p text-marino">
                  Search Log
                </label>
                <input
                  type="text"
                  placeholder="Search logs..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="form-control border-marino f-parrafo fs-p text-dk"
                  style={{
                    width: "180px",
                    height: "40px",
                  }}
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label className="form-label f-bold fs-p text-marino required">
                  Predefined Times
                </label>
                <select
                  className="form-select border-marino f-parrafo fs-p text-dk"
                  style={{ width: "200px", height: "40px" }}
                  value={predefinedRange}
                  onChange={handlePredefinedChange}
                >
                  <option value="">No selection</option>
                  <option value="lastHour">Last hour</option>
                  <option value="last24">Last 24 hours</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="custom">Custom</option>
                </select>
              </div>

              {showDateTimeFields && (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label className="form-label f-bold fs-p text-marino required">
                    Date/Time Range
                  </label>
                  <div style={{ width: "305px", minHeight: "40px" }}>
                    <GenericDateTimeRangePicker
                      value={dateRange}
                      onChange={(val) => setDateRange(val)}
                      displayFormat="yyyy-MM-dd HH:mm"
                      disabled={false}
                    />
                  </div>
                </div>
              )}
            </div>

            <div>
              <button
                type="submit"
                onClick={Datoslogs}
                className="btn-gradiente"
                style={{
                  padding: "6px 14px",
                  height: "40px",
                  minWidth: "120px",
                }}
              >
                {loading ? "Searching..." : "Search"}
              </button>
            </div>
          </div>

          <div className="border shadow-sm rounded-lg">
            <div
              className="relative w-full overflow-auto menu-scroll"
              ref={containerRef}
            >
              <div className="border shadow-sm rounded-lg">
                <table className="w-full caption-bottom f-parrafo custom-table">
                  <thead>
                    <tr className="text-azul">
                      <th
                        onClick={() => handleSort("timestamp")}
                        style={{ cursor: "pointer" }}
                        className="table-cell"
                      >
                        <div className={styles["header-content"]}>
                          <span>Timestamp</span>
                          <span className={styles["sortable-column"]}>
                            {getSortIcon("timestamp")}
                          </span>
                        </div>
                      </th>
                      <th
                        onClick={() => handleSort("level")}
                        style={{ cursor: "pointer" }}
                        className="table-cell text-xs"
                      >
                        <div className={styles["header-content"]}>
                          <span>Severity Level</span>
                          <span className={styles["sortable-column"]}>
                            {getSortIcon("level")}
                          </span>
                        </div>
                      </th>
                      <th className="table-cell">Message</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedData.length === 0 ? (
                      <tr>
                        <td
                          colSpan={3}
                          style={{
                            textAlign: "center",
                            color: "gray",
                            padding: "20px",
                          }}
                        >
                          No Data Available
                        </td>
                      </tr>
                    ) : (
                      sortedData.map((messages: logs, i: number) => (
                        <tr className="table-row" key={i}>
                          <td className="table-cell">{messages.timestamp}</td>
                          <td className="table-cell severity-level">
                            {messages.level === "ERROR" && (
                              <div className="badge-error">
                                {messages.level}
                              </div>
                            )}
                            {messages.level === "DEBUG" && (
                              <div className="badge-debug">
                                {messages.level}
                              </div>
                            )}
                            {messages.level === "INFO" && (
                              <div className="badge-info">
                                {messages.level}
                              </div>
                            )}
                            {messages.level === "WARNING" && (
                              <div className="badge-warning">
                                {messages.level}
                              </div>
                            )}
                            {messages.level === "CRITICAL" && (
                              <div className="badge-critical">
                                {messages.level}
                              </div>
                            )}
                          </td>
                          <td className="table-cell">{messages.log}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
